module.exports = __webpack_public_path__ + "static/images/productDetail.dcd6927.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/domesticTradeCredit/productDetail.png
// module id = GDzN
// module chunks = 0